import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import TBody from '../common/table/tBody';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import DateFormat from '../common/dateFormat/DateFormat';
import { sortData } from '../common/table/sortHelper';

import CargaForm from './cargaForm';
import CargaHistoricoProducao from './cargaHistoricoProducao';
import {
	setModoTela,
	initForm,
	salvar,
	excluir,
	getLista,
	getListaProducoes,
	getHistoricoProducao,
	limparHistoricoProducao
} from './cargaActions';
import { getLista as getListaVeiculo } from '../veiculo/veiculoActions';
import { getLista as getListaMotorista } from '../motorista/motoristaActions';

const columns = [{
	field: 'id',
	type: 'int'
}, {
	field: 'data_agendamento',
	type: 'date'
}, {
	field: 'status',
	type: 'text'
}, {
	field: 'placa_veiculo',
	type: 'text'
}, {
	field: 'nome_motorista',
	type: 'text'
}, {
	field: 'quantidade_producoes',
	type: 'int'
}];

class Carga extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: '',
		sort: {
			field: 'data_agendamento',
			direction: 'desc'
		}
	};

	componentDidMount() {
		this.props.getLista();
		this.props.getListaVeiculo();
		this.props.getListaMotorista();
	}

	prepararRegistro(item) {
		return {
			...item,
			producoes: (item.producoes || []).map(producao => ({
				id_producao: producao.id_producao,
				ordem: producao.ordem
			}))
		};
	}

	abrirCadastro(item, modo) {
		const registro = this.prepararRegistro(item);
		this.props.setModoTela(modo, registro);
		this.props.initForm(registro);
		this.props.getListaProducoes(registro.data_agendamento);
	}

	filtrar() {
		const pesquisa = (this.state.pesquisar || '').trim().toUpperCase();

		const lista = (this.props.lista || []).filter(item => {
			if (!pesquisa) {
				return true;
			}

			const producoes = item.producoes || [];
			const texto = `
				${item.id}
				${item.status}
				${item.placa_veiculo}
				${item.nome_motorista}
				${DateFormat.formatarDataSqlParaTela(item.data_agendamento)}
				${producoes.map(producao => producao.id_producao).join(' ')}
				${producoes.map(producao => producao.id_solicitacao).join(' ')}
				${producoes.map(producao => producao.nome_parceiro).join(' ')}
				${producoes.map(producao => producao.nome_racao).join(' ')}
			`.toUpperCase();

			return pesquisa
				.split('+')
				.filter(parte => parte.trim())
				.every(parte => texto.includes(parte.trim()));
		});

		return sortData(lista, this.state.sort, columns);
	}

	onSort(field) {
		this.setState(prev => ({
			sort: {
				field,
				direction: prev.sort.field === field && prev.sort.direction === 'asc'
					? 'desc'
					: 'asc'
			}
		}));
	}

	lista() {
		const lista = this.filtrar();

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<InputPesquisa
							cols='12 6 3 1'
							label='Pesquisar'
							minWidth={344}
							onChange={value => this.setState({ pesquisar: value })} />

						<div style={{ marginTop: 8, width: 95 }}>
							<a
								className='btn btn-app bg-primary'
								style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => this.props.getLista()}>
								<i className='fas fa-sync-alt'></i> Atualizar
							</a>
						</div>
					</Row>
				</ContentCardHeader>

				<ContentCardBody>
					<Table
						responsive
						border
						alturaFixa
						striped
						maxHeight={window.innerWidth < 631 ? window.innerHeight - 260 : window.innerHeight - 180}>
						<THead>
							<Tr>
								<ThSort field='id' label='Número' width={70} sort={this.state.sort} onSort={field => this.onSort(field)} />
								<ThSort field='data_agendamento' label='Data' width={100} sort={this.state.sort} onSort={field => this.onSort(field)} />
								<ThSort field='status' label='Situação' width={100} sort={this.state.sort} onSort={field => this.onSort(field)} />
								<ThSort field='placa_veiculo' label='Veículo' width={110} sort={this.state.sort} onSort={field => this.onSort(field)} />
								<ThSort field='nome_motorista' label='Motorista' width={180} sort={this.state.sort} onSort={field => this.onSort(field)} />
								<ThSort field='quantidade_producoes' label='Produções' width={90} sort={this.state.sort} onSort={field => this.onSort(field)} />
								<Th sticky>Sequência</Th>
								<Th sticky>Parceiros</Th>
								<Th sticky alignCenter width={120}></Th>
							</Tr>
						</THead>

						<TBody>
							{lista.map((item, indice) => {
								const producoes = item.producoes || [];
								const parceiros = [...new Set(producoes.map(producao => producao.nome_parceiro).filter(Boolean))];
								const ordens = producoes.map(producao => producao.ordem).filter(ordem => ordem != null);
								const sequencia = ordens.length
									? `${Math.min(...ordens)} até ${Math.max(...ordens)}`
									: producoes.map(producao => producao.id_producao).join(', ');

								return (
									<Tr
										key={item.id}
										backgroundColor={this.state.linhaSelecionada === item.id ? '#bcc7eb' : (indice % 2 === 0 ? '#ffffff' : '#f5f5f5')}>
										<Td alignCenter onClick={() => this.setState({ linhaSelecionada: item.id })}>{item.id}</Td>
										<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_agendamento)}</Td>
										<Td alignCenter>{item.status}</Td>
										<Td alignCenter>{item.placa_veiculo}</Td>
										<Td>{item.nome_motorista}</Td>
										<Td alignCenter>{item.quantidade_producoes == null ? producoes.length : item.quantidade_producoes}</Td>
										<Td>{sequencia}</Td>
										<Td>{parceiros.join(', ')}</Td>
										<Td alignCenter minWidth={120}>
											<ButtonTable
												type='info'
												width={32}
												small
												icon='fas fa-history'
												visible={true}
												title='Histórico da produção'
												event={() => this.props.getHistoricoProducao(item.id)} />
											<ButtonTable
												type='warning'
												width={32}
												small
												icon='fas fa-pencil-alt'
												visible={true}
												title='Editar ou substituir veículo/motorista'
												event={() => this.abrirCadastro(item, 'cadastro')} />

										</Td>
									</Tr>
								);
							})}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	render() {
		return (
			<div>
				<CargaHistoricoProducao
					idCarga={this.props.idCargaHistorico}
					lista={this.props.historicoProducao}
					onFechar={this.props.limparHistoricoProducao} />
				<Content>
					<Aguardando aguardando={this.props.aguardando} />
					{this.props.modoTela === 'cadastro' && <CargaForm onSubmit={registro => this.props.salvar(registro)} />}
					{this.props.modoTela === 'exclusao' && <CargaForm excluir onSubmit={this.props.excluir} />}
					{this.props.modoTela === 'lista' && this.lista()}
				</Content>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	modoTela: state.carga.modoTela,
	aguardando: state.carga.aguardando,
	lista: state.carga.lista,
	idCargaHistorico: state.carga.idCargaHistorico,
	historicoProducao: state.carga.historicoProducao
});

const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela,
	initForm,
	salvar,
	excluir,
	getLista,
	getListaProducoes,
	getHistoricoProducao,
	limparHistoricoProducao,
	getListaVeiculo,
	getListaMotorista
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Carga);
